import React, { Component } from 'react';
import { request } from 'http';

// radioOff.png
// radioOn.png

export default class Head extends Component {

	render() {
		const {on} = this.props
		return <div style={{...this.props.style, 
			transform:"scale(0.5)",
			marginRight: 5
		}}>
			<img src={!on ? require("../../Comp/img/radioOff.png") : require("../../Comp/img/radioOn.png")} style={{
			}} />
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/dComp/shared/Radio.js